import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { servicesAPI } from 'supporticon/utils/client'
import { isJustGiving } from '../../../lib/environment'
import { clearSession, refreshUser, selectUser } from '../../../store/session'

class Reconnect extends React.Component {
  constructor () {
    super()
    this.refreshTokenIfNeeded = this.refreshTokenIfNeeded.bind(this)
  }

  componentDidMount () {
    this.refreshTokenIfNeeded()
    this.interval = setInterval(this.refreshTokenIfNeeded, 30000)
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  refreshTokenIfNeeded () {
    const { clearSession, refreshUser, user = {} } = this.props

    const shouldRefreshToken = isJustGiving() && user.refreshToken &&
      moment().isSameOrAfter(user.tokenExpiry, 'second')

    if (shouldRefreshToken) {
      const body = { token: user.refreshToken }
      servicesAPI.post('/v1/justgiving/oauth/reconnect', body)
        .then(response => response.data)
        .then(data => {
          const params = {
            refreshToken: data.refresh_token,
            token: data.access_token,
            tokenExpiry: moment().add(data.expires_in || 3600, 'seconds').toISOString(),
            authType: 'Bearer'
          }

          refreshUser(params)
        })
        .catch(error => {
          clearSession()
          return Promise.reject(error)
        })
    }
  }

  render () {
    return this.props.children
  }
}

const mapStateToProps = state => ({
  user: selectUser(state)
})

const mapDispatchToProps = { clearSession, refreshUser }

export default connect(mapStateToProps, mapDispatchToProps)(Reconnect)
